import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { getCurrentPosition, getPositionHistory } from 'src/thunks/job-thunks';

export const useJobs = () => {
  const dispatch = useDispatch();

  const { list, current, history } = useSelector((state: RootStateOrAny) => state.job);

  const handleGetCurrentJob = (pin: string | number) => {
    if (!current.isLoading) dispatch(getCurrentPosition(pin));
  };

  const handleGetJobsHistory = (pin: string | number) => {
    if (!history.isLoading) dispatch(getPositionHistory(pin));
  };

  // console.log(history);

  return {
    list,
    current,
    history: history?.error ? [] : history,
    // ? history.data.sort(function (a: any, b: any) {
    //     return Number(new Date(a?.start_date)) - Number(new Date(b?.start_date));
    //   })
    // : [],
    // ?.filter((item: any) => !item.hasOwnProperty('start_date'))
    handleGetCurrentJob,
    handleGetJobsHistory,
  };
};
